import Model from "../Model";

class KpiComercialUser extends Model{

    buildUrl ({ param }) {
        return ['kpizone/getdimensionbyuserregion', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiComercialUser;